import React, {ReactNode} from 'react';

import {StandardTextFieldProps, TextField} from "@mui/material";


export interface TextFieldWithValidationProps extends StandardTextFieldProps {
    hasError?: any | boolean | null | undefined,
    errorText?: ReactNode,
}

interface IState {
}

export default class TextFieldWithValidation extends React.Component<TextFieldWithValidationProps, IState> {

    render() {
        const {hasError, errorText} = this.props;
        const area = {...this.props}
        if (hasError != null && hasError !== false) {
            area.error = true;
            if (errorText) {
                area.helperText = errorText;
            } else {
                area.helperText = hasError;
            }
        }
        if (!area.InputLabelProps) {
            area.InputLabelProps = {
                shrink: true,
            }
        }

        delete area.errorText
        delete area.hasError

        return <TextField{...area} />
    }
}